import Image from 'components/common/Image';
import { Box, Markdown, Text } from 'grommet';
import usePageTitle from 'hooks/usePageTitle';
import useResponsive from 'hooks/useResponsive';
import EditAssetButton from 'modules/admin/components/EditAssetButton';
import FileActionEditor from 'modules/admin/components/FileActionEditor';
import { newsViewModel$ } from 'modules/news/news$';
import React from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'rxbeach/react';
import { Asset } from 'types';

const SingleNews = ({ byShortid }: { byShortid: Record<string, Asset> }) => {
  const { isMobile } = useResponsive();
  const param = useParams<{ id: string }>();
  const asset = byShortid?.[param?.id || ''];
  usePageTitle(asset?.label);
  if (!asset) return null;
  const { markdown, image, id, label } = asset;
  return (
    <Box
      as="article"
      justify="center"
      align="center"
      direction={isMobile ? 'column' : 'row'}
      animation="fadeIn"
      fill="horizontal"
      height={{ min: 'large' }}
      pad={isMobile ? 'medium' : undefined}
    >
      {image && (
        <Box
          elevation="large"
          background="light-3"
          height="medium"
          width={isMobile ? '100%' : 'medium'}
          flex={false}
        >
          <Image src={image} />
        </Box>
      )}
      <Box
        width={{ max: 'large' }}
        fill={isMobile ? 'horizontal' : undefined}
        justify="center"
        pad={isMobile ? { vertical: 'medium' } : 'medium'}
        margin={isMobile ? undefined : { left: 'medium' }}
        style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
      >
        <Text size="xlarge" weight="bold">
          {label}
        </Text>
        <Markdown>{markdown}</Markdown>
        <EditAssetButton
          shortid={asset.shortid}
          label="Endre nyhet"
          type="nyheter"
        />
        <FileActionEditor id={id} />
      </Box>
    </Box>
  );
};

export default connect(SingleNews, newsViewModel$);
